// @flow strict
import * as React from 'react';

import styles from './top-bar.css';
import whiteLayersIconSvg from './images/layers-white-36dp.svg';
import svgImageFn from './svg-image.jsx';
import iconStyles from './icons.css';

const LayersIcon = svgImageFn(iconStyles.large, '', whiteLayersIconSvg, true);

const TopBar = (): React.Node => {
  return (
    <span className={styles.bar} data-cy="topBar">
      <span className={styles.leftSide}>
        <LayersIcon />
        <span className={styles.titleText} data-cy="title-text">
          Achievement Level Explorer for Educators
        </span>
      </span>
    </span>
  );
};

export { TopBar };
